export const ACCEPT_CONFIG = {
    image: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
    video: ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv'],
    document: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt', '.tif', '.tiff'],
    install: ['.ipa','.apk', '.pkg', '.exe'],
    getAll(){
        // return [...this.image, ...this.video, ...this.document]
        return [...this.install]
    },
};